import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import React from "react";
import { useLanguage } from "../LanguageContext";
import { Helmet } from "react-helmet-async";
import Swal from "sweetalert2";

function Payment() {
  const API_URL = process.env.REACT_APP_API_URL;
  const IMG_BASE_URL = process.env.REACT_APP_API_BASE_URL_img;
  const { lang } = useLanguage();

  const [apiData, setApiData] = useState(null);
  const [PageData, setPageData] = useState(null);
  const { slug } = useParams();

  const getPage = async () => {
    if (!slug) return;
    try {
      const res = await axios.get(`${API_URL}/pages/get/slug/${slug}`, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });

      setPageData(res.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getData = async (apiName) => {
    try {
      const res = await axios.get(`${API_URL}/${apiName}`, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });

      setApiData(res.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getPage();
  }, [slug]);

  useEffect(() => {
    if (PageData?.apiName) {
      getData(PageData?.apiName);
    }
  }, [PageData?.apiName]);

  useEffect(() => {
  Swal.fire({
    title: "Important Notice",
    text: "Kindly submit the signed hard copy of the payment receipt to the Finance Section for further processing.",
    icon: "info",
    confirmButtonText: "OK",
    confirmButtonColor: "#0d6efd",
    allowOutsideClick: false,
  });
}, []);
  return (
    <div className="main-wrapper">
      {/* ================= SEO START ================= */}
      <Helmet>
        <title>{PageData?.pageTitle?.[lang] || "Technical Staff"}</title>

        <meta
          name="description"
          content={PageData?.metaDescription?.[lang] || ""}
        />

        <meta name="keywords" content={PageData?.keyWord?.[lang] || ""} />

        <meta property="og:title" content={PageData?.pageTitle?.[lang]} />
        <meta
          property="og:description"
          content={PageData?.metaDescription?.[lang]}
        />
        <meta
          property="og:image"
          content={`${IMG_BASE_URL}/${PageData?.photo}`}
        />
      </Helmet>
      {/* ================= SEO END ================= */}
      <section
        className="banner-section position-relative"
        style={{
          backgroundImage: `url(${IMG_BASE_URL}/${PageData?.photo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="banner-title z_index1">
                <h1 className="banner-slider-title fw-500 text-white">
                  {PageData?.pageTitle?.[lang]}
                </h1>
                <ul className="breadcrumb-area m-0 p-0">
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li>
                    <i className="fa-solid fa-angle-right"></i>
                  </li>
                  <li className="breadcrumb-title">
                    {PageData?.pageTitle?.[lang]}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="payment-section body-shape section-padding">
        <div className="container">
          <div className="qr-wrapper">
            <div className="row">
              <div className="col-lg-7 col-xl-6">
                <div className="payment-details h-100">
                   <div className="text-center">
                  <h4>
                    {lang === "hi" ? " बैंक लेन-देन " : " Bank Transaction"}
                    <hr />
                  </h4>
                </div>
                  <div
                    className="title-name m-0 fw-600 fs-16 slow-effect"
                    dangerouslySetInnerHTML={{
                      __html: apiData?.[0]?.bankDetails?.[lang],
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-5 col-xl-6">
                <div className="or-code-column h-100">
                  <div className="gr-code-image text-center">
                   <h4>
                    {lang === "hi" ? " यूपीआई लेन-देन " : " UPI Transaction"}
                    <hr />
                  </h4>
                  <img
                    src={`${IMG_BASE_URL}/${apiData?.[0]?.photo}`}
                    alt={apiData?.[0]?.photoTitle}
                  />
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Payment;
